module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Not sure which size fits you best? {link} to check the size recommended by AI!","label_link":"Click here"}}')
  delete Component.options._Ctor
}
